import Vue from "vue";
import Router from "vue-router";
Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index/index'),
      meta: { title: '商品列表' },
      alias: '/'
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/user/user'),
      meta: { title: '个人信息' },
    },
    {
      path: '/goodsEdit',
      name: 'goodsEdit',
      component: () => import('@/views/goodsEdit/goodsEdit'),
      meta: { title: '商品编辑' },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
      meta: { title: '登录' },
    },
  ]
})